module.exports = __webpack_public_path__ + "static/media/Combined Shape-1@1.5x.43e9295b.svg";